const BigCus = [
    {id: "0", value: "大戶"},    
    {id: "1", value: "散戶"}
  ];  
  
  export default BigCus  